import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import Navbar from '../components/Navbar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      await axios.get(`${API}/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage('Your email has been verified successfully!');
      toast.success('Email verified!');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Verification failed');
      toast.error('Verification failed');
    }
  };

  return (
    <div>
      <Navbar />
      <div className="booking-page" style={{ paddingTop: '100px' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto', padding: '2rem', textAlign: 'center' }}>
          {status === 'verifying' && (
            <>
              <h1 className="booking-title">Verifying Email...</h1>
              <p style={{ color: '#666', marginTop: '1rem' }}>Please wait while we verify your email address.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
              <h1 className="booking-title">Email Verified!</h1>
              <p style={{ color: '#666', marginTop: '1rem' }}>{message}</p>
              <p style={{ color: '#666', marginTop: '1rem' }}>Redirecting to login...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
              <h1 className="booking-title">Verification Failed</h1>
              <p style={{ color: '#666', marginTop: '1rem' }}>{message}</p>
              <button
                className="cta-button"
                onClick={() => navigate('/login')}
                style={{ marginTop: '2rem' }}
              >
                Go to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
